import React, { createContext, useContext, useState } from "react";

export type UserType = "customer" | "driver";
export type TimePeriod = "daily" | "weekly" | "monthly";

interface DashboardFilterContextValue {
  userType: UserType;
  timePeriod: TimePeriod;
  setUserType: (value: UserType) => void;
  setTimePeriod: (value: TimePeriod) => void;
}

const defaultValue: DashboardFilterContextValue = {
  userType: "customer",
  timePeriod: "weekly",
  setUserType: () => {},
  setTimePeriod: () => {},
};

const DashboardFilterContext = createContext<DashboardFilterContextValue>(defaultValue);

// eslint-disable-next-line react-refresh/only-export-components
export const useDashboardFilter = () => {
  const ctx = useContext(DashboardFilterContext);
  if (!ctx) throw new Error("useDashboardFilter must be used within DashboardFilterProvider");
  return ctx;
};

interface DashboardFilterProviderProps {
  children: React.ReactNode;
}

export const DashboardFilterProvider: React.FC<DashboardFilterProviderProps> = ({ children }) => {
  const [userType, setUserType] = useState<UserType>("customer");
  const [timePeriod, setTimePeriod] = useState<TimePeriod>("weekly");

  const value: DashboardFilterContextValue = {
    userType,
    timePeriod,
    setUserType,
    setTimePeriod,
  };

  return (
    <DashboardFilterContext.Provider value={value}>
      {children}
    </DashboardFilterContext.Provider>
  );
};
